import CustomPlanSidebar from "components/organisms/CustomPlanSidebar/CustomPlanSidebar";
import EditMeasureSidebar from "components/organisms/MeasureSidebars/EditMeasureSidebar";
import NewProjectSidebar from "components/organisms/MeasureSidebars/NewProjectSidebar";
import { useBuildingModelUid } from "hooks/useBuildingModelUid";
import { useBuildingModelHeaderQuery } from "queries/useBuildingModelHeaderQuery";
import useBuildingSidebarState from "recoilStore/CustomPlan/useBuildingSidebarState";
import useMeasureSidebarState from "recoilStore/CustomPlan/useMeasureSidebarState";
import BuildingSidebar from "../BuildingSidebar";

function BuildingPageSidebars() {
    const buildingModelUid = useBuildingModelUid();

    // Recoil store
    const { state: sidebarState, setState: setSidebarState } = useBuildingSidebarState();
    const { state: measureSidebarState, setState: setMeasureSidebarState } = useMeasureSidebarState();

    const { data: headerData } = useBuildingModelHeaderQuery(buildingModelUid);

    return (
        <>
            <BuildingSidebar
                show={sidebarState.isSidebarOpen}
                onClose={() => {
                    setSidebarState({ ...sidebarState, isSidebarOpen: false });
                }}
                buildingName={headerData?.buildingName || ""}
            />

            <CustomPlanSidebar
                sidebarOpen={sidebarState.isCustomPlanSidebarOpen}
                closeSidebar={() =>
                    setSidebarState({
                        ...sidebarState,
                        isCustomPlanSidebarOpen: false,
                    })
                }
                buildingModelUid={buildingModelUid}
                currentCustomPlanName={sidebarState.currentCustomPlanDetails?.name || ""}
                currentCarbonReductionPlanUid={sidebarState.currentCustomPlanDetails?.id || ""}
            />

            <EditMeasureSidebar
                sidebarOpen={measureSidebarState.isEditOpen}
                closeSidebar={() =>
                    setMeasureSidebarState((prevState) => ({
                        ...prevState,
                        isEditOpen: false,
                    }))
                }
                buildingModelUid={buildingModelUid}
                currentCarbonReductionPlanUid={sidebarState.currentCustomPlanDetails?.id || ""}
            />

            <NewProjectSidebar
                sidebarOpen={measureSidebarState.isCreateOpen}
                closeSidebar={() =>
                    setMeasureSidebarState((prevState) => ({
                        ...prevState,
                        isCreateOpen: false,
                        createMeasurePrefill: null,
                    }))
                }
                buildingModelUid={buildingModelUid}
                currentCarbonReductionPlanUid={sidebarState.currentCustomPlanDetails?.id || ""}
            />
        </>
    );
}

export default BuildingPageSidebars;
